// extracted by mini-css-extract-plugin
module.exports = {"unit":"var(--ring-unit)","button":"AddJob__button--rA JobTile__job--L4","icon":"AddJob__icon--WC","name":"AddJob__name--dH JobTile__name--Zw"};